/* =====================================================================
   FICHE OSLO (LePetitSabotier) — comportements des blocs/sections lps-
   Tout passe par délégation d'événements : ça continue de marcher quand
   Prestige ré-affiche le bloc produit (changement de variante, Kaching…).
   ===================================================================== */
(function () {
  if (window.__lpsOslo) return;
  window.__lpsOslo = true;

  var JOURS = ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."];
  var MOIS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];

  /* « Expédié d'ici le … » = aujourd'hui + N jours ouvrés (calcul côté navigateur) */
  function dates(root) {
    (root || document).querySelectorAll("[data-lps-ship]").forEach(function (el) {
      var n = parseInt(el.getAttribute("data-lps-ship"), 10) || 0;
      var d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      var txt = JOURS[d.getDay()] + " " + d.getDate() + " " + MOIS[d.getMonth()];
      if (el.textContent !== txt) el.textContent = txt;
    });
  }

  /* Barres de progression des carrousels (vidéos clients, détails) */
  function bar(track) {
    var wrap = track.closest("[data-lps-carousel]");
    var b = wrap && wrap.querySelector(".lps-bar span");
    if (!b) return;
    var r = track.clientWidth / Math.max(track.scrollWidth, 1);
    var max = track.scrollWidth - track.clientWidth;
    b.style.width = Math.min(100, r * 100) + "%";
    b.style.transform = "translateX(" + (max > 0 ? (track.scrollLeft / max) * (100 / r - 100) : 0) + "%)";
    wrap.querySelector(".lps-bar").style.visibility = max > 2 ? "visible" : "hidden";
  }
  function bars(root) { (root || document).querySelectorAll("[data-lps-track]").forEach(bar); }
  document.addEventListener("scroll", function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute("data-lps-track")) bar(t);
  }, true);
  window.addEventListener("resize", function () { bars(); });

  /* Accordéons : un seul ouvert à la fois dans un même groupe */
  document.addEventListener("toggle", function (e) {
    var d = e.target;
    if (!d || d.tagName !== "DETAILS" || !d.open) return;
    var g = d.getAttribute("data-lps-group");
    if (!g) return;
    document.querySelectorAll('details[data-lps-group="' + g + '"][open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  /* Fenêtres (<dialog>) : ouvrir / fermer */
  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-lps-open]");
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute("data-lps-open"));
      if (dlg && dlg.showModal) { e.preventDefault(); dlg.showModal(); }
      return;
    }
    if (e.target.closest(".lps-dialog__close")) { var c = e.target.closest("dialog"); if (c) c.close(); return; }
    if (e.target.tagName === "DIALOG" && e.target.classList.contains("lps-dialog")) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }

    /* Vidéos clients : clic = lecture / pause */
    var tile = e.target.closest(".lps-ugc__tile");
    if (tile) {
      var v = tile.querySelector("video");
      if (!v) return;
      if (v.paused) {
        document.querySelectorAll(".lps-ugc__tile video").forEach(function (o) { if (o !== v) { o.pause(); o.closest(".lps-ugc__tile").classList.remove("is-playing"); } });
        v.muted = false; v.play(); tile.classList.add("is-playing");
      } else { v.pause(); tile.classList.remove("is-playing"); }
      return;
    }

    /* Ancres « En savoir plus sur » (dont les avis Trustoo) */
    var a = e.target.closest(".lps-ancres__list a");
    if (a) {
      var sel = a.getAttribute("href");
      var target = null;
      try { target = document.querySelector(sel); } catch (err) {}
      if (!target && a.hasAttribute("data-lps-fallback")) {
        a.getAttribute("data-lps-fallback").split(",").some(function (s) { target = document.querySelector(s.trim()); return !!target; });
      }
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: "smooth", block: "start" }); }
    }
  });

  function init(root) { dates(root); bars(root); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();

  /* Prestige ré-affiche le bloc produit : on relance le remplissage */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; init(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Barre flottante façon Qomfort : pastilles de couleur + flèche vers la zone d'achat + rappel remise.
     - apparaît quand la section produit (photos + achat) est presque sortie de l'écran ;
     - une pastille change la couleur de la 1re paire dans Kaching (ou dans le sélecteur Prestige) ;
     - la flèche ramène au bloc d'achat. Remplace l'ancien bouton « remonter en haut ». */
  var BARRE_CSS = ".lps-barre{position:fixed;left:0;right:0;bottom:0;z-index:99;padding:20px;pointer-events:none;transform:translateY(100%);transition:transform .3s ease-in-out,bottom .2s}"
    + ".lps-barre.is-visible{transform:none}"
    + ".lps-barre__in{pointer-events:auto;max-width:400px;margin:0 auto;padding:12px;border-radius:12px;background:var(--lps-sand,#F4F3F0);box-shadow:0 0 20px rgba(0,0,0,.3)}"
    + ".lps-barre__row{display:flex;align-items:center;justify-content:space-between;gap:20px}"
    + ".lps-barre__defile{position:relative;min-width:0;flex:1;overflow-x:auto;scrollbar-width:none;padding-right:10px}"
    + ".lps-barre__defile::-webkit-scrollbar{display:none}"
    + ".lps-barre__couleurs{display:flex;flex-wrap:nowrap;align-items:flex-start;gap:12px;padding:5px;width:max-content}"
    + ".lps-barre__pastille{display:block;flex:none;width:32px;height:32px;padding:0;margin:0;border-radius:50%;border:2px solid transparent;background:var(--c);cursor:pointer;transition:box-shadow .2s;box-sizing:border-box;-webkit-tap-highlight-color:transparent}"
    + ".lps-barre__pastille[style*='#ffffff'],.lps-barre__pastille[style*='#fff;']{border-color:#DDD}"
    + ".lps-barre__pastille.is-on{box-shadow:0 0 0 2px #fff,0 0 0 4px var(--lps-forest,#2C4A34)}"
    + ".lps-barre__pastille:focus-visible{outline:2px solid var(--lps-forest,#2C4A34);outline-offset:4px}"
    + ".lps-barre__go{position:relative;flex:none;display:inline-flex;align-items:center;justify-content:center;min-width:74px;padding:15.3px 16px;border-radius:100px;background:var(--lps-forest,#2C4A34);color:#fff;transition:background-color .2s}"
    + ".lps-barre__go::before{content:'';position:absolute;left:-64px;top:-2px;width:64px;height:100%;background:linear-gradient(90deg,rgba(244,243,240,0) 0%,var(--lps-sand,#F4F3F0) 70%);pointer-events:none}"
    + ".lps-barre__go:hover{background:#23392A}"
    + ".lps-barre__go svg{width:15px;height:13px}"
    + ".lps-barre .lps-barre__msg{display:flex;align-items:center;gap:12px;margin:10px 0 0;padding:0;color:var(--lps-ok-ink,#1F5A30);font-size:14px;line-height:normal}"
    + ".lps-barre__msg strong{font-weight:700}"
    + ".lps-barre__ok{flex:none;width:20px;height:20px;border-radius:50%;background:#2E9A4F;color:#fff;display:grid;place-items:center}"
    + ".lps-barre__ok .lps-icon{width:12px;height:12px}"
    + "@media (max-width:425px){.lps-barre__msg{gap:10px;font-size:13px}}"
    + "@media (prefers-reduced-motion:reduce){.lps-barre{transition:none}}"
    + "product-sticky-bar{display:none!important}"
    /* Bulle de chat Commslayer : sur téléphone, elle monte au-dessus de la barre tant que la barre est affichée.
       (Commslayer bloque « bottom » en !important, d'où « translate ».) Hauteur calculée dans bulle(). */
    + "html .woot-widget-bubble{transition:opacity .25s ease,visibility .25s ease,translate .3s ease-in-out}"
    + "@media (max-width:599px){html.lps-barre-on .woot-widget-bubble{translate:0 calc(-1 * var(--lps-bulle,125px))}}";

  function selectsKaching(noms) {
    return Array.prototype.filter.call(document.querySelectorAll("select.kaching-bundles__bar-variant-select"), function (s) {
      if (!s.offsetParent) return false;
      return Array.prototype.some.call(s.options, function (o) { return noms.indexOf(o.text.trim()) > -1; });
    });
  }
  function radiosPrestige(nom) {
    var out = null;
    document.querySelectorAll("variant-picker input[type=radio], .variant-picker input[type=radio]").forEach(function (i) {
      var l = document.querySelector('label[for="' + i.id + '"]');
      if (!out && l && l.textContent.trim() === nom) out = i;
    });
    return out;
  }

  /* Hauteur des éléments fixés en haut de l'écran (bandeau d'annonce + en-tête collant) */
  function hautFixe() {
    var bas = 0;
    [5, 30, 60, 90, 120, 150].forEach(function (y) {
      var el = document.elementFromPoint(window.innerWidth / 2, y);
      while (el && el !== document.documentElement) {
        var p = window.getComputedStyle(el).position;
        if (p === "fixed" || p === "sticky") {
          var r = el.getBoundingClientRect();
          if (r.top <= bas + 2 && r.bottom > bas && r.height < window.innerHeight / 2) bas = r.bottom;
          break;
        }
        el = el.parentElement;
      }
    });
    return bas;
  }

  function barre() {
    var tpl = document.getElementById("lps-barre-tpl");
    if (!tpl || document.getElementById("lps-barre")) return;
    var st = document.createElement("style"); st.id = "lps-barre-css"; st.textContent = BARRE_CSS; document.head.appendChild(st);
    document.body.appendChild(tpl.content.cloneNode(true));
    var bar = document.getElementById("lps-barre");
    var pastilles = Array.prototype.slice.call(bar.querySelectorAll(".lps-barre__pastille"));
    var noms = pastilles.map(function (p) { return p.getAttribute("data-couleur"); });

    function marquer(nom) {
      pastilles.forEach(function (p) { var on = p.getAttribute("data-couleur") === nom; p.classList.toggle("is-on", on); p.setAttribute("aria-checked", on ? "true" : "false"); });
    }
    function couleurActuelle() {
      var s = selectsKaching(noms)[0];
      if (s) return s.options[s.selectedIndex].text.trim();
      var c = document.querySelector("variant-picker input[type=radio]:checked");
      var l = c && document.querySelector('label[for="' + c.id + '"]');
      return l ? l.textContent.trim() : null;
    }
    function choisir(nom) {
      var s = selectsKaching(noms)[0];
      if (s) {
        var o = Array.prototype.find.call(s.options, function (x) { return x.text.trim() === nom; });
        if (o) { s.value = o.value; s.dispatchEvent(new Event("input", { bubbles: true })); s.dispatchEvent(new Event("change", { bubbles: true })); }
      } else {
        var r = radiosPrestige(nom);
        if (r) { var l = document.querySelector('label[for="' + r.id + '"]'); (l || r).click(); }
      }
      marquer(nom);
    }
    var depart = couleurActuelle(); if (depart) marquer(depart);

    bar.addEventListener("click", function (e) {
      var p = e.target.closest(".lps-barre__pastille");
      if (p) { choisir(p.getAttribute("data-couleur")); return; }
      if (e.target.closest(".lps-barre__go")) {
        e.preventDefault();
        var cible = document.querySelector("kaching-bundles-block") || document.querySelector('[data-block-type="buy-buttons"]') || document.querySelector("product-info, .product-info");
        if (!cible) return;
        window.scrollTo({ top: cible.getBoundingClientRect().top + window.scrollY - hautFixe() - 16, behavior: "smooth" });
      }
    });
    /* Kaching / Prestige → barre */
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (t && (t.matches("select.kaching-bundles__bar-variant-select") || t.matches("variant-picker input[type=radio]"))) {
        setTimeout(function () { var n = couleurActuelle(); if (n) marquer(n); }, 50);
      }
    }, true);

    /* Afficher / masquer : visible quand la section produit n'est plus (ou presque plus) à l'écran */
    /* Hauteur dont la bulle de chat doit monter : haut de la carte + 12 px d'écart */
    function bulle() {
      var c = bar.querySelector(".lps-barre__in");
      if (!c) return;
      var off = parseFloat(bar.style.bottom) || 0;
      document.documentElement.style.setProperty("--lps-bulle", Math.round(c.getBoundingClientRect().height + 12 + off) + "px");
    }
    function montrer(v) {
      bar.classList.toggle("is-visible", v);
      document.documentElement.classList.toggle("lps-barre-on", v);
      if (v) bulle();
    }
    var info = document.querySelector("product-info, .product-info");
    var section = info && (info.closest(".shopify-section") || info);
    if (section && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { montrer(!en.isIntersecting); });
      }, { threshold: 0.1 }).observe(section);
    } else { montrer(true); }

    /* Aperçu Shopify seulement : au-dessus de la barre d'aperçu (invisible pour les clients) */
    function apercu() {
      var pb = document.getElementById("PBarNextFrameWrapper");
      var q = pb && pb.getBoundingClientRect();
      bar.style.bottom = q && q.height && q.top < window.innerHeight ? (window.innerHeight - q.top) + "px" : "";
      bulle();
    }
    apercu(); window.addEventListener("resize", apercu); setTimeout(apercu, 1500);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", barre);
  else barre();

  /* Éditeur de thème */
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
  document.addEventListener("shopify:block:select", function (e) {
    var d = e.target.matches && e.target.matches("details") ? e.target : e.target.querySelector && e.target.querySelector("details");
    if (d) d.open = true;
  });
})();
